module.exports = __webpack_public_path__ + "kg.svg?a3bb66b0fc08b8ecb2fe304ad8e0ebc3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kg.svg
// module id = 849
// module chunks = 27